module.exports = __webpack_public_path__ + "img/intro_10.0731119d.jpeg";